import { stdObject } from "../../../../data/types/stdObject";

export const updateOffer = (
  country: string,
  index: number,
  data: stdObject,
  params: stdObject,
) => {
  const { windowValues2 } = params;
  windowValues2.PRE.offers[country][index] = {
    ...windowValues2.PRE.offers[country][index],
    ...data,
  };
};
